import { render } from "./personalAdditionalInfo.vue?vue&type=template&id=7846447d&scoped=true"
import script from "./personalAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./personalAdditionalInfo.vue?vue&type=script&lang=js"

import "./personalAdditionalInfo.vue?vue&type=style&index=0&id=7846447d&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7846447d"]])

export default __exports__